import { Checkbox, FormControlLabel } from "@mui/material";

import { useFormikContext } from "formik";
import { AddClientFormValues, EditClientFormValues } from "../../types";

function IsPrivateLedgerCheckBox() {
  const context = useFormikContext<
    AddClientFormValues | EditClientFormValues
  >();

  return (
    <FormControlLabel
      control={
        <Checkbox
          id="is-private-ledger"
          checked={context.values["is-private-ledger"] || false}
          onChange={context.handleChange}
        />
      }
      label="Private ledger on client dashboard"
    />
  );
}

export default IsPrivateLedgerCheckBox;
